module.exports = __webpack_public_path__ + "img/9791187142867.7231e537.jpg";